import React, { useEffect, useMemo, useRef, useState } from "react";

// [iso, English, العربية, dial code] — الترتيب هو ترتيب الظهور قبل البحث
export const COUNTRIES = [
  ["ae", "United Arab Emirates", "الإمارات", "971"],
  ["sa", "Saudi Arabia", "السعودية", "966"],
  ["qa", "Qatar", "قطر", "974"],
  ["kw", "Kuwait", "الكويت", "965"],
  ["bh", "Bahrain", "البحرين", "973"],
  ["om", "Oman", "عُمان", "968"],
  ["eg", "Egypt", "مصر", "20"],
  ["jo", "Jordan", "الأردن", "962"],
  ["lb", "Lebanon", "لبنان", "961"],
  ["iq", "Iraq", "العراق", "964"],
  ["sy", "Syria", "سوريا", "963"],
  ["ps", "Palestine", "فلسطين", "970"],
  ["ye", "Yemen", "اليمن", "967"],
  ["ly", "Libya", "ليبيا", "218"],
  ["tn", "Tunisia", "تونس", "216"],
  ["dz", "Algeria", "الجزائر", "213"],
  ["ma", "Morocco", "المغرب", "212"],
  ["sd", "Sudan", "السودان", "249"],
  ["tr", "Türkiye", "تركيا", "90"],
  ["ir", "Iran", "إيران", "98"],
  ["il", "Israel", "إسرائيل", "972"],
  ["pk", "Pakistan", "باكستان", "92"],
  ["in", "India", "الهند", "91"],
  ["bd", "Bangladesh", "بنغلاديش", "880"],
  ["lk", "Sri Lanka", "سريلانكا", "94"],
  ["np", "Nepal", "نيبال", "977"],
  ["af", "Afghanistan", "أفغانستان", "93"],
  ["ph", "Philippines", "الفلبين", "63"],
  ["id", "Indonesia", "إندونيسيا", "62"],
  ["my", "Malaysia", "ماليزيا", "60"],
  ["sg", "Singapore", "سنغافورة", "65"],
  ["th", "Thailand", "تايلاند", "66"],
  ["vn", "Vietnam", "فيتنام", "84"],
  ["cn", "China", "الصين", "86"],
  ["hk", "Hong Kong", "هونغ كونغ", "852"],
  ["jp", "Japan", "اليابان", "81"],
  ["kr", "South Korea", "كوريا الجنوبية", "82"],
  ["au", "Australia", "أستراليا", "61"],
  ["nz", "New Zealand", "نيوزيلندا", "64"],
  ["gb", "United Kingdom", "المملكة المتحدة", "44"],
  ["ie", "Ireland", "أيرلندا", "353"],
  ["fr", "France", "فرنسا", "33"],
  ["de", "Germany", "ألمانيا", "49"],
  ["it", "Italy", "إيطاليا", "39"],
  ["es", "Spain", "إسبانيا", "34"],
  ["pt", "Portugal", "البرتغال", "351"],
  ["nl", "Netherlands", "هولندا", "31"],
  ["be", "Belgium", "بلجيكا", "32"],
  ["ch", "Switzerland", "سويسرا", "41"],
  ["at", "Austria", "النمسا", "43"],
  ["se", "Sweden", "السويد", "46"],
  ["no", "Norway", "النرويج", "47"],
  ["dk", "Denmark", "الدنمارك", "45"],
  ["fi", "Finland", "فنلندا", "358"],
  ["pl", "Poland", "بولندا", "48"],
  ["cz", "Czechia", "التشيك", "420"],
  ["gr", "Greece", "اليونان", "30"],
  ["cy", "Cyprus", "قبرص", "357"],
  ["ro", "Romania", "رومانيا", "40"],
  ["bg", "Bulgaria", "بلغاريا", "359"],
  ["ua", "Ukraine", "أوكرانيا", "380"],
  ["ru", "Russia", "روسيا", "7"],
  ["kz", "Kazakhstan", "كازاخستان", "7"],
  ["uz", "Uzbekistan", "أوزبكستان", "998"],
  ["az", "Azerbaijan", "أذربيجان", "994"],
  ["ge", "Georgia", "جورجيا", "995"],
  ["am", "Armenia", "أرمينيا", "374"],
  ["us", "United States", "الولايات المتحدة", "1"],
  ["ca", "Canada", "كندا", "1"],
  ["mx", "Mexico", "المكسيك", "52"],
  ["br", "Brazil", "البرازيل", "55"],
  ["ar", "Argentina", "الأرجنتين", "54"],
  ["co", "Colombia", "كولومبيا", "57"],
  ["cl", "Chile", "تشيلي", "56"],
  ["za", "South Africa", "جنوب أفريقيا", "27"],
  ["ng", "Nigeria", "نيجيريا", "234"],
  ["ke", "Kenya", "كينيا", "254"],
  ["gh", "Ghana", "غانا", "233"],
  ["et", "Ethiopia", "إثيوبيا", "251"],
  ["mu", "Mauritius", "موريشيوس", "230"],
];

export const getCountry = (iso) => COUNTRIES.find((c) => c[0] === iso) || COUNTRIES[0];

// اسم الدولة بأي لغة (المتصفح بيترجمه لوحده: روسي، ألماني، فرنساوي، إسباني، إيطالي، عبري، صيني ...)
const namesCache = {};
const countryName = (row, lang) => {
  const [iso, en, ar] = row;
  if (lang === "en") return en;
  if (lang === "ar") return ar;
  try {
    if (!namesCache[lang]) namesCache[lang] = new Intl.DisplayNames([lang], { type: "region" });
    return namesCache[lang].of(iso.toUpperCase()) || en;
  } catch {
    return en;
  }
};

// العلم صورة (الإيموجي مبيظهرش على ويندوز)
const Flag = ({ iso }) => (
  <img
    className="cflag"
    src={`https://flagcdn.com/w40/${iso}.png`}
    srcSet={`https://flagcdn.com/w80/${iso}.png 2x`}
    width="24"
    height="18"
    alt=""
    loading="lazy"
  />
);

const Chevron = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const PhoneField = ({ label, searchLabel, noResults, lang, country, number, onCountry, onNumber }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const wrap = useRef(null);
  const search = useRef(null);
  const isRtl = lang === "ar" || lang === "he";
  const current = getCountry(country);
  const nameOf = (row) => countryName(row, lang);

  const list = useMemo(() => {
    const s = q.trim().toLowerCase().replace(/^\+/, "");
    if (!s) return COUNTRIES;
    return COUNTRIES.filter(
      (row) =>
        row[1].toLowerCase().includes(s) ||
        row[2].includes(s) ||
        countryName(row, lang).toLowerCase().includes(s) ||
        row[3].startsWith(s) ||
        row[0] === s
    );
  }, [q, lang]);

  // قفل القايمة لما تدوس برّا + فوكس على البحث أول ما تفتح
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (wrap.current && !wrap.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onDown);
    search.current?.focus();
    return () => document.removeEventListener("pointerdown", onDown);
  }, [open]);

  const pick = (iso) => {
    onCountry(iso);
    setOpen(false);
    setQ("");
  };

  return (
    <div
      className="cfield cphone"
      ref={wrap}
      onKeyDown={(e) => {
        if (e.key === "Escape") setOpen(false);
      }}
    >
      <span>{label}</span>

      <div className="cphone__row" dir="ltr">
        <button
          type="button"
          className="cphone__btn"
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label={`${nameOf(current)} +${current[3]}`}
          onClick={() => setOpen((o) => !o)}
        >
          <Flag iso={current[0]} />
          <b>+{current[3]}</b>
          <Chevron />
        </button>
        <input
          type="tel"
          required
          minLength={6}
          autoComplete="tel-national"
          inputMode="tel"
          value={number}
          onChange={(e) => onNumber(e.target.value.replace(/[^\d\s]/g, ""))}
        />
      </div>

      {open && (
        <div className="cphone__panel" dir={isRtl ? "rtl" : "ltr"} data-lenis-prevent>
          <input
            ref={search}
            className="cphone__search"
            type="search"
            placeholder={searchLabel}
            aria-label={searchLabel}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                if (list[0]) pick(list[0][0]);
              }
            }}
          />
          <ul className="cphone__list" role="listbox">
            {list.map((row) => {
              const [iso, , , dial] = row;
              return (
              <li key={iso} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={iso === country}
                  className={`cphone__opt ${iso === country ? "is-on" : ""}`}
                  onClick={() => pick(iso)}
                >
                  <Flag iso={iso} />
                  <span className="cphone__name">{nameOf(row)}</span>
                  <span className="cphone__dial" dir="ltr">
                    +{dial}
                  </span>
                </button>
              </li>
              );
            })}
            {!list.length && <li className="cphone__empty">{noResults}</li>}
          </ul>
        </div>
      )}
    </div>
  );
};